(function () {
  console.log("🎁 GiftEngine v7 init");

  if (!window.GIFT_ENGINE_CONFIG) return;

  const config = window.GIFT_ENGINE_CONFIG;

  const ATTR_1 = "_free_gift_1";
  const ATTR_2 = "_free_gift_2";

  let running = false;
  let lastCartHash = null;

  function hashCart(cart) {
    return (cart.items || [])
      .map((i) =>
        [
          i.key,
          i.variant_id,
          i.quantity,
          i.properties?.[ATTR_1] || "",
          i.properties?.[ATTR_2] || ""
        ].join(":")
      )
      .join("|");
  }

  function isGift1(item) {
    return item?.properties?.[ATTR_1] === "true";
  }

  function isGift2(item) {
    return item?.properties?.[ATTR_2] === "true";
  }

  function getSubtotal(cart) {
    return (cart.items || []).reduce((sum, item) => {
      if (isGift1(item) || isGift2(item)) return sum;
      return sum + Number(item.final_line_price || 0);
    }, 0);
  }

  function milestone1Reached(cart) {
    return getSubtotal(cart) >= Math.round(Number(config?.milestone1?.threshold || 0) * 100);
  }

  function milestone2Reached(cart) {
    return getSubtotal(cart) >= Math.round(Number(config?.milestone2?.threshold || 0) * 100);
  }

  async function fetchJSON(url, options = {}) {
    const headers = { ...(options.headers || {}) };

    if (options.method && options.method !== "GET" && !headers["Content-Type"]) {
      headers["Content-Type"] = "application/json";
    }

    const res = await fetch(url, {
      credentials: "same-origin",
      ...options,
      headers
    });

    const text = await res.text();
    let data = null;

    try {
      data = text ? JSON.parse(text) : null;
    } catch (e) {
      data = text;
    }

    if (!res.ok) {
      throw new Error(`Request failed: ${res.status} ${typeof data === "string" ? data : JSON.stringify(data)}`);
    }

    return data;
  }

  async function getCart() {
    return fetchJSON("/cart.js");
  }

  // Batch remove: set multiple keys to 0 in one request
  async function removeItems(items) {
    if (!items.length) return;
    const updates = {};
    for (const item of items) {
      updates[item.key] = 0;
    }
    return fetchJSON("/cart/update.js", {
      method: "POST",
      body: JSON.stringify({ updates })
    });
  }

  // Batch add: add all variants in one request
  async function addVariants(variantIds, attrKey) {
    if (!variantIds.length) return;
    return fetchJSON("/cart/add.js", {
      method: "POST",
      body: JSON.stringify({
        items: variantIds.map((id) => ({
          id,
          quantity: 1,
          properties: { [attrKey]: "true" }
        }))
      })
    });
  }

  async function refresh(cart) {
    window.GA_CART = cart;
    window.dispatchEvent(new CustomEvent("cart:updated", { detail: cart }));
    window.dispatchEvent(new CustomEvent("cart:refresh"));
  }

  async function ensureGifts(cart) {
    const m1 = milestone1Reached(cart);
    const m2 = milestone2Reached(cart);

    const items = cart.items || [];

    const gift1 = items.filter(isGift1);
    const gift2 = items.filter(isGift2);

    // Milestone 2 reached: remove gift1, keep/add gift2 only
    if (m2) {
      await removeItems(gift1);
      if (gift2.length === 0) {
        await addVariants(config.milestone2.products || [], ATTR_2);
      }
      return;
    }

    // Milestone 1 reached (but not milestone 2): remove gift2, keep/add gift1 only
    if (m1) {
      await removeItems(gift2);
      if (gift1.length === 0) {
        await addVariants(config.milestone1.products || [], ATTR_1);
      }
      return;
    }

    // Below milestone 1: remove all gifts in one call
    const allGifts = [...gift1, ...gift2];
    await removeItems(allGifts);
  }

  async function normalize(cart) {
    if (running) return;
    running = true;

    try {
      const hash = hashCart(cart);

      if (hash === lastCartHash) {
        running = false;
        return;
      }

      lastCartHash = hash;

      if (!config.enabled) {
        running = false;
        return;
      }

      await ensureGifts(cart);

      const fresh = await getCart();
      lastCartHash = hashCart(fresh);
      await refresh(fresh);
    } catch (e) {
      console.error("GiftEngine error", e);
    }

    running = false;
  }

  window.addEventListener("cart:updated", async (e) => {
    if (!e.detail) return;
    await normalize(e.detail);
  });

  document.addEventListener("DOMContentLoaded", async () => {
    try {
      const cart = window.GA_CART || await getCart();
      await normalize(cart);
    } catch (e) {
      console.error("GiftEngine init error", e);
    }
  });
})();
